import { get, writable } from 'svelte/store';
import { ProjectService } from '../../services/project.service';
import moment from 'moment';
import { ReportsService } from "../../services/reports.service";
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const recordsActions = writable([]);
export const pagination = writable(null);
export const tasks = writable([]);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export function resetSearchFilter() {
    filter.set({ criteria: {}, params: null, sorting: "" });
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _resp = await ProjectService.getProjectActions(_filter).toPromise();
        let r = _resp.payload;
        records.set(r);
        pagination.set({ currentPage: 1, totalPages: Math.floor(r.length / 10), totalRecords: r.length });
        recordsActions.set(r.slice(0, 10));
        computeTasks(r);
    }
    finally {
        loading.set(false);
    }
}
export function onPageChange(pageNumber) {
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    let rec = get(records);
    recordsActions.set(rec.slice(pageNumber * 10, pageNumber * 10 + 10));
}
export function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    load();
}
export function clearSearch() {
    resetSearchFilter();
    search();
}
function computeTasks(actions) {
    let t = [];
    actions.forEach(x => {
        if (x.dataInizio != null) {
            let v = {
                id: x.codiceAzione.toString(),
                name: x.descrizioneAzione,
                start: x.dataInizio,
                end: x.dataFine == null ? moment().add(1, 'year').toDate() : x.dataFine,
                progress: x.pianificato == 0 ? 0 : (x.erogato / x.pianificato) * 100
            };
            t.push(v);
        }
    });
    tasks.set(t);
    onEdit(null);
}
export function onExportProjectActions() {
    let _filter = get(filter);
    ReportsService.exportExcelProjectActions(_filter);
}
export function onEdit(record) {
    console.log(record);
}
